import ApiService from './api.service'
import { Error } from './responses/Error';
import moment from 'moment';

const StatsDeklaracjeService = {

    /**
     * Get total stats deklaracje for Current User
     *
     * @returns total
     * @throws Error
     **/
    getTotal: async function(forceRefresh :boolean = false) {
        try {
        let attr = (forceRefresh) ? '?forceRefresh=true' : '';
        const response = await ApiService.get('/api/stats-deklaracje/total' + attr);
        return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get total stats deklaracje for Current User from last year
     *
     * @returns total
     * @throws Error
     **/
    getTotalLastYear: async function(forceRefresh :boolean = false) {
        try {
            let attr = (forceRefresh) ? '?forceRefresh=true' : '';
            const response = await ApiService.get('/api/stats-deklaracje/total-last-year-to-same-date' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get aggregated stats deklaracje for Current User
     *
     * @returns list
     * @throws Error
     **/
    getAggregatedBetweenDates: async function(dateFrom :string, dateTo :string = moment().format('YYYY-MM-DD'), lastYear :boolean= false, forceRefresh: boolean = false) {
        try {
            let attr = '?date_from='+dateFrom+'&date_to='+dateTo;
            if (lastYear) attr += '&year=last';
            if (forceRefresh) attr += '&forceRefresh=true';

            const response = await ApiService.get('/api/stats-deklaracje/aggregated-list-between-dates' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get stats deklaracje sum between dates for Current User or Product between dates
     *
     * @returns list
     * @throws Error
     **/
    getSumBetweenDates: async function(productId :number|null = null, dateFrom :string, dateTo :string = moment().format('YYYY-MM-DD'), lastYear :boolean= false) {
        try {
            let product = (productId) ? '/'+productId : '';
            let attr = '?date_from='+dateFrom+'&date_to='+dateTo;
            if (lastYear) attr += '&year=last';

            const response = await ApiService.get('/api/stats-deklaracje/sum-between-dates' + product + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get detailed stats deklaracje for Current User between dates
     *
     * @returns list
     * @throws Error
     **/
    getListBetweenDates: async function(productId :number|null = null, dateFrom :string, dateTo :string = moment().format('YYYY-MM-DD'), lastYear :boolean= false) {
        try {
            let product = (productId) ? '/'+productId : '';
            let attr = '?date_from='+dateFrom+'&date_to='+dateTo;
            if (lastYear) attr += '&year=last';

            const response = await ApiService.get('/api/stats-deklaracje/list' + product + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

}

export default StatsDeklaracjeService

export { StatsDeklaracjeService }
